import React, { useCallback } from 'react';
import { selector, useRecoilValue, useSetRecoilState } from 'recoil';
import { firstPortfolioInView, isAllocatorOpenState, isReportState } from 'venn-state';
import { Icon } from 'venn-ui-kit';
import { withSuspense } from 'venn-utils';
import { EmptyStudioAllocatorWindow } from './components';
import { StudioAllocatorSubject } from './StudioAllocatorSubject';
import { ResizableAllocationPanelWrapper } from './ResizableAllocationPanelWrapper';

const hasPortfolioInViewState = selector<boolean>({
  key: 'hasPortfolioInView',
  get: ({ get }) => !!get(firstPortfolioInView),
});

export const StudioEmptyAllocationPanel = withSuspense(
  null,
  React.memo(function EmptyAllocationPanel() {
    const setIsAllocatorOpen = useSetRecoilState(isAllocatorOpenState);

    const onClosePanel = useCallback(() => {
      setIsAllocatorOpen(false);
    }, [setIsAllocatorOpen]);

    const isReport = useRecoilValue(isReportState);
    const hasPortfolioInView = useRecoilValue(hasPortfolioInViewState);

    const panelContent = (
      <EmptyStudioAllocatorWindow>
        <StudioAllocatorSubject onClose={onClosePanel} hideCompareLink disabled={false} />

        <div
          data-testid="studio-empty-allocator-wrapper"
          className="[grid-area:allocator-panel] overflow-x-hidden bg-slate-100"
        >
          <div className="px-[6px] py-[12px] flex flex-col items-center gap-[12px]">
            <Icon type="empty-set" prefix="fat" className="text-slate-200 text-8xl" />
            <div className="text-sm">
              {hasPortfolioInView
                ? 'Select a portfolio above to edit allocations.'
                : `Add a portfolio to this ${isReport ? 'report' : 'Studio analysis'} to edit allocations.`}
            </div>
          </div>
        </div>
      </EmptyStudioAllocatorWindow>
    );

    return <ResizableAllocationPanelWrapper>{panelContent}</ResizableAllocationPanelWrapper>;
  }),
);
